{
  "cms.create.error.scheduleStandalone": "Creation succeeded, but scheduling the publish failed. The schedule was not saved."
}
